var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactSupportTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.977
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5V.945a.936.936 0 01.293-.63A.837.837 0 01.9 0h11.677a.868.868 0 01.63.3.918.918 0 01.293.641v8.01a.936.936 0 01-.293.63.856.856 0 01-.63.315H3.6zm4.523.9a.872.872 0 01-.619-.315.921.921 0 01-.3-.63v-2.2H14.85V3.6h2.25a.837.837 0 01.607.315.956.956 0 01.293.653v13.41L14.423 14.4zM12.15 1.35H1.35v8.888L3.037 8.55h9.113zm-10.8 0z"
  })));
}

export default SvgContactSupportTeam;